import buildingBrand from "@/assets/building-brand.jpeg";
import socialMediaOffer from "@/assets/social-media-offer.jpeg";

const OffersSection = () => {
  return (
    <section className="py-12 md:py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-5 py-2 rounded-full gradient-cta text-primary-foreground text-xs font-semibold tracking-widest uppercase mb-4">Special Offers</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-foreground mb-4">
            Our Latest Offers
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-sm md:text-base">
            Check out our special packages and offers designed to help your brand grow faster.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto">
          <div className="group rounded-2xl overflow-hidden border border-border shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
            <img
              src={buildingBrand}
              alt="Build Your Empire - Transform your business into a brand with Graphic Lines"
              className="w-full h-auto object-cover"
            />
            <div className="p-4 md:p-6 bg-card">
              <h3 className="text-lg md:text-xl font-bold text-foreground mb-2">Build Your Empire</h3>
              <p className="text-xs md:text-sm text-muted-foreground mb-3 md:mb-4">Transform your business into a brand with our complete marketing, designing, managing, and pro editing services.</p>
              <a
                href="https://wa.me/+923058559591"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex px-5 py-2.5 md:px-6 md:py-3 rounded-full gradient-cta text-primary-foreground font-display font-semibold text-sm hover:opacity-90 transition-opacity"
              >
                Get This Offer
              </a>
            </div>
          </div>

          <div className="group rounded-2xl overflow-hidden border border-border shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
            <img
              src={socialMediaOffer}
              alt="Social Media Management Packages - Basic, Premium, and Growth Plans"
              className="w-full h-auto object-cover"
            />
            <div className="p-4 md:p-6 bg-card">
              <h3 className="text-lg md:text-xl font-bold text-foreground mb-2">Social Media Management Packages</h3>
              <p className="text-xs md:text-sm text-muted-foreground mb-3 md:mb-4">Choose from Basic (Rs 17,000), Growth (Rs 31,000), or Premium (Rs 54,000) plans for complete social media management.</p>
              <a
                href="https://wa.me/+923058559591"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex px-5 py-2.5 md:px-6 md:py-3 rounded-full gradient-cta text-primary-foreground font-display font-semibold text-sm hover:opacity-90 transition-opacity"
              >
                Get This Package
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OffersSection;
